export default [
    {
        path: 'rira-parametrizacao',
        component: () => import(/* webpackChunkName: 'integracao-rira-parametrizacao' */ '@/views/integracao/rira/parametrizacao/Index'),
        redirect: 'rira-parametrizacao/create',
        children: [
            {
                name: 'integracao-rira-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-rira-parametrizacao' */ '@/views/integracao/rira/parametrizacao/Form'),
            },
        ],
    },
]